module.exports = __webpack_public_path__ + "static/media/Poppins-Regular-latinext.0ed299a4.woff2";